var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    {
      staticClass: "m-0 px-8",
      attrs: { id: "explore", "data-cy": "explore-container", fluid: "" },
    },
    [
      _c(
        "div",
        {
          class: { "explore-header": true, scrolled: _vm.isWindowScrolled },
          attrs: { "data-cy": "explore-header" },
        },
        [
          _c(
            "v-row",
            {
              staticClass: "mb-3",
              staticStyle: { "align-items": "baseline" },
              attrs: { "no-gutters": "", "data-cy": "explore-header-row" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "py-3 ma-0",
                  attrs: {
                    cols: "8",
                    fluid: "",
                    "data-cy": "explore-title-col",
                  },
                },
                [
                  _c("h3", {
                    attrs: { id: "title-page", "data-cy": "explore-title" },
                    domProps: {
                      textContent: _vm._s(_vm.$t("explore.title-page")),
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c("v-spacer", { attrs: { "data-cy": "explore-spacer" } }),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass:
                    "pa-0 ma-0 text-right d-flex justify-end align-center",
                  attrs: { cols: "4", "data-cy": "btn-my-team-col" },
                },
                [
                  _c("BtnEditRates", {
                    staticClass: "ml-2",
                    attrs: { "data-cy": "btn-edit-rates" },
                  }),
                  _vm._v(" "),
                  _c("BtnMyTeam", {
                    staticClass: "ml-4",
                    attrs: {
                      teamRequestId: _vm.teamRequestId,
                      "data-cy": "btn-my-team",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            {
              staticClass: "flex-nowrap",
              attrs: { "data-cy": "top-filter-row" },
            },
            [
              _c(
                "v-col",
                { attrs: { cols: 12 } },
                [
                  _c("TopFilter", {
                    attrs: {
                      stemdoers: _vm.stemdoers,
                      rates: _vm.rates,
                      defaultClientSelector: _vm.defaultClientSelector,
                      defaultCompanySelector: _vm.defaultCompanySelector,
                      "data-cy": "top-filter",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-row",
            {
              staticClass: "pb-2",
              attrs: { align: "center", "data-cy": "availability-row" },
            },
            [
              _c(
                "v-col",
                { attrs: { "data-cy": "no-result-info-col" } },
                [
                  _c("NoResultInfo", {
                    attrs: {
                      display: _vm.isFilteredByClosestMatch,
                      "data-cy": "no-result-info",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "mr-0 pr-0",
                  attrs: { cols: "auto", "data-cy": "switch-availability-col" },
                },
                [
                  _c("SwitchAvailability", {
                    attrs: {
                      filterField: _vm.FilterFields.Available,
                      action: _vm.changeAvailableFilter,
                      tempFilters: false,
                      "data-cy": "switch-availability",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.displaySkeleton
        ? _c(
            "v-row",
            { attrs: { "data-cy": "skeleton-row" } },
            [
              _vm.displaySkeleton
                ? [
                    _c("StemdoerListSkeleton", {
                      attrs: { "data-cy": "stemdoer-list-skeleton" },
                    }),
                  ]
                : _vm._e(),
            ],
            2
          )
        : !_vm.isLoading &&
          !_vm.displaySkeleton &&
          _vm.visibleStemdoers.length > 0
        ? _c(
            "v-row",
            { staticClass: "pt-1", attrs: { "data-cy": "stemdoer-list-row" } },
            [
              _c("StemdoerList", {
                attrs: {
                  stemdoers: _vm.visibleStemdoers,
                  addStemdoerToCart: _vm.addStemdoerToCart,
                  rates: _vm.rates,
                  "data-cy": "stemdoer-list",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isStemdoersListEmpty
        ? _c(
            "v-row",
            {
              staticClass: "fadeIn align-center justify-center",
              attrs: { "no-gutters": "", "data-cy": "empty-list-row" },
            },
            [
              [
                _c("EmptyStemdoerList", {
                  attrs: { "data-cy": "empty-stemdoer-list" },
                }),
              ],
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }